<template>
  <div>
    <!--    driver name-->
    <v-row
      style="border-bottom: 1px solid #E5E7EB;"
      class="margin-0"
    >
      <v-col
        class="d-flex justify-start driver-label"
      >
        <div
          class="driver-label--wrapper"
        >
          {{ $t('base/session.session') }}
        </div>
      </v-col>

      <v-col
        class="d-flex justify-end"
      >
        <active-icon
          :cell-data="item.deactivated_at || ''"
          class="mr-2"
        />

        <table-row-actions-menu
          :data-index="itemIndex"
          :config="actionsConfig"
          :table-data="data"
        />
      </v-col>
    </v-row>

    <v-row
      v-for="(dataObject, dataObjIndex) in getAllItemDetails()"
      :key="dataObjIndex"
      class="margin-0"
    >
      <v-col
        class="data-label"
      >
        {{ dataObject.label }}
      </v-col>

      <v-col
        class="d-flex justify-end data-value"
      >
        <template
          v-if="dataObject && dataObject.key === 'current_session'"
        >
          <active-icon
            :cell-data="dataObject.value"
            :config="dataObject.config"
          />
        </template>
        <template
          v-else
        >
          {{ dataObject.value }}
        </template>
      </v-col>
    </v-row>

    <information-dialog
      :open-dialog="informationDialogData.show"
      :title="informationDialogData.title"
      :dialog-message="informationDialogData.message"
      :positive-button-text="informationDialogData.positiveBtnText"
      :negative-button-text="informationDialogData.negativeBtnText"
      :confirm-callback-function="informationDialogData.callback"
      @close="$set(informationDialogData, 'show', false)"
    />
  </div>
</template>

<script>
import ActiveIcon from './ActiveIcon.vue'
import TableRowActionsMenu from '@/global/components/table/components/TableRowActionsMenu.vue'
import InformationDialog from '@/global/components/dialogs/InformationDialog.vue'
import sessionsMixin from '../mixins/sessionsMixin'
import { deleteAction } from '@/global/components/table/helpers/tableActions'

export default {
  name: 'SessionGridBlock',

  components: {
    InformationDialog,
    TableRowActionsMenu,
    ActiveIcon
  },

  mixins: [
    sessionsMixin
  ],

  props: {
    data: {
      type: Array,
      default: () => ([])
    },
    item: {
      type: Object,
      required: true,
      default: () => ({})
    },
    itemIndex: {
      type: Number,
      default: 0
    }
  },

  data () {
    return {
      informationDialogData: {
        show: false,
        message: '',
        title: '',
        positiveBtnText: '',
        negativeBtnText: this.$t('base.cancel'),
        callback: () => {}
      }
    }
  },

  computed: {
    actionsConfig () {
      return {
        tableConfig: {
          actionsConfig: [
            deleteAction(this.$t, (event) => this.onDeleteSession(event))
          ]
        }
      }
    }
  },

  methods: {
    getAllItemDetails () {
      return [
        {
          label: this.$t('base/session.ip_address'),
          value: this.item?.ip_address || '--'
        },
        {
          label: this.$t('base/session.user_agent'),
          value: this.item?.user_agent || '--'
        },
        {
          label: this.$t('base/session.last_activity'),
          value: this.item?.last_activity || '--'
        },
        {
          key: 'current_session',
          config: {
            src: () => {
              return this.item?.current_session?.description === 'Aktivno' ? '/img/icons/green-check-circle.svg' : '/img/icons/grey-check-circle.svg'
            }
          },
          label: this.$t('base/session.current_session'),
          value: this.item?.current_session?.description || '--'
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.driver-label {
  display: flex;
  justify-content: flex-start;
  font-family: 'Satoshi', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0;
  color: #111827;
  align-items: center;
  padding-top: 0;
  padding-bottom: 0;
}

.driver-label--wrapper {
  display: flex;
  height: 48px;
  align-items: center;
}

.data-label {
  font-family: 'Satoshi', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0;
  color: #6B7280;
}

.data-value {
  font-family: 'Satoshi', sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0;
  color: #111827;
  text-align: right;
}

.arrowUpDown {
  position: absolute;
  bottom: 10px;
  left: 50%;
}

.arrowUpDown:hover {
  cursor: pointer;
}
</style>
